const data_structure = [
    {
        id: "1",
        name : "Dr. Ferry Julianto",
        department : "Pembina",
    },
    {
        id: "2",
        name : "Dr. Indra Martian Permana, M.Ag",
        department : "Direktur",
    },
    {
        id: "3",
        name : "Ari Malik Ibrahim",
        department : "Manager Program",
    },
    {
        id: "4",
        name : "Khoirussifa",
        department : "Sekretaris",
    },
    {
        id: "5",
        name : "Azkiyatur Rifhany",
        department : "Bendahara",
    },
    {
        id: "6",
        name : "Indah Trisnawati, S.Ikom",
        department : "Humas & PR",
    },
    {
        id: "7",
        name : "Dyah Ayu, S.Ikom",
        department : "Digital Marketing",
    },
    {
        id: "8",
        name : "Muhammad Rifqi Azkia",
        department : "Desaign Grafis",
    },

];

export default data_structure;